import request from "./api";
/**
 *    individualApi   开课管理api
 * */

// 获取教师端课程通知列表
export const getNoticeList = (params, opts) =>
    request('/api-cms/msg/find', params, {
        ...opts,
        method: 'post'
    });
// 获取学生端课程通知列表
export const getNoticeStudentList = (params, opts) =>
    request('/api-cms/msg/findStudent', params, {
        ...opts,
        method: 'post'
    });
// 新增课程通知
export const addNotice = (params, opts) =>
    request('/api-cms/msg/add', params, {
        ...opts,
        method: 'post'
    });
// 所有的教学班
export const getAllTeachClass = (courseId, params, opts) =>
    request('/api-course/class/teacher/'+courseId, params, {
        ...opts
    });
// 删除通知
export const delNotice = (id, params, opts) =>
    request('/api-cms/msg/'+id, params, {
        ...opts,
        method: 'delete'
    });
// 修改通知
export const updateNotice = (params, opts) =>
    request('/api-cms/msg/update', params, {
        ...opts,
        method: 'post'
    });
// 创建班级
export const addClass = (params, opts) =>
    request('/api-course/class/add', params, {
        ...opts,
        method: 'post'
    });
// 查询教学班
export const getTeachClass = (params, opts) =>
    request('/api-course/class/share/query', params, {
        ...opts,
        method: 'post'
    });
// 修改教学班
export const updateTeachClass = (params, opts) =>
    request('/api-course/class/update', params, {
        ...opts,
        method: 'put'
    });
// 删除教学班
export const delTeachClass = (id, params, opts) =>
    request('/api-course/class/'+id, params, {
        ...opts,
        method: 'delete'
    });
// 教学班中全部的学员列表
export const getStudentList = (params, opts) =>
    request('/api-course/class/get', params, {
        ...opts,
        method: 'post'
    });
// 行政班级
export const getTeachingClass = (params, opts) =>
    request('/api-teachingaffair/teachingAffair/teachingClass', params, {
        ...opts
    });
// 单个删除学员
export const delStudent = (id, params, opts) =>
    request('/api-course/class/student/'+id, params, {
        ...opts,
        method: 'delete'
    });
// 批量删除学员
export const delBatchStudent = (params, opts) =>
    request('/api-course/class/student/batch', params, {
        ...opts,
        method: 'post'
    });
// 查询所有的学员
export const getAllStudent = (params, opts) =>
    request('/api-teachingaffair/teachingAffair/queryStudentPage', params, {
        ...opts,
        method: 'post'
    });
// 导入学员到班级中
export const addStudentInto = (params, opts) =>
    request('/api-course/class/addUser', params, {
        ...opts,
        method: 'post'
    });
// 表格导入学员到班级中
export const uploadStudentInto = (params, opts) =>
    request('/api-course/class/excel/upload', params, {
        ...opts,
        method: 'post'
    });
// 获取所有的待批名单
export const getApprovedList = (params, opts) =>
    request('/api-course/class/share/get', params, {
        ...opts,
        method: 'post'
    });
// 批量审核通过
export const batchStudent = (params, opts) =>
    request('/api-course/class/student/batch/update', params, {
        ...opts,
        method: 'post'
    });
// 批量审核拒绝
export const batchnoStudent = (params, opts) =>
    request('/api-course/class/student/batch', params, {
        ...opts,
        method: 'post'
    });
// 学生端单项训练列表
export const getIndividualStuList = (params, opts) =>
    request('/api-course/class/student', params, {
        ...opts,
        method: 'post'
    });
// 单项训练学生加入班级
export const intoClass = (params, opts) =>
    request('/api-course/class/share/addUser', params, {
        ...opts,
        method: 'post'
    });
// 教师端获取课程
export const getTeachCourse = (params, opts) =>
    request('/api-course/course/share/query', params, {
        ...opts,
        method: 'post'
    });
// 教师端获取课程
export const getTeachCourseNew = (params, opts) =>
    request('/api-course/course/circulate/queryAll', params, {
        ...opts,
        method: 'post'
    });
// 教师端单项训练获取课程下的所有班级
export const getCourseClass = (params, opts) =>
    request('/api-course/class/share/query', params, {
        ...opts,
        method: 'post'
    });
// 教师端单项训练查询单个课程信息
export const getCourseMsg = (courseId, params, opts) =>
    request('/api-course/class/share/teacher/sta/'+courseId, params, {
        ...opts
    });
// 添加测验保存
export const saveTest = (params, opts) =>
    request('/api-course/catalog/add/material', params, {
        ...opts,
        method: 'post'
    });
// 编辑测验保存
export const saveEditorTest = (params, opts) =>
    request('/api-course/update/course/exam/test', params, {
        ...opts,
        method: 'post'
    });
// 获取所有的测验试卷
export const getPaperList = (params, opts) =>
    request('/api-resource/testPaper/selectTestPaPer', params, {
        ...opts,
        method: 'post'
    });
export const getPaperListByCourseId = (params, opts) =>
    request('/api-resource/testPaper/getTestPaPerByCourseId', params, {
        ...opts,
        method: 'post'
    });
// 保存课程考核
export const saveAssessment = (courseId, params, opts) =>
    request('/api-course/course/appraise/'+courseId, params, {
        ...opts,
        method: 'post'
    });
// 获取考试列表
export const getTestList = (courseId, params, opts) =>
    request('/api-study/course/exam/list/'+courseId, params, {
        ...opts
    });
// 获取课程考核
export const getTestStandard = (courseId, params, opts) =>
    request('/api-course/course/default/appraise/'+courseId, params, {
        ...opts
    });
// 获取岗位介绍
export const getPostIntroduce = (subjectId, params, opts) =>
    request('/api-resource/station/'+subjectId, params, {
        ...opts
    });
// 获取小组列表
export const getGroupList = (params, opts) =>
    request('/api-course/team/queryTeams', params, {
        ...opts,
        method: 'post'
    });
// 单个删除小组
export const delGroup = (groupId, params, opts) =>
    request('/api-course/team/'+groupId, params, {
        ...opts,
        method: 'delete'
    });
// 批量删除小组
export const delAllGroup = (params, opts) =>
    request('/api-course/team/batch', params, {
        ...opts,
        method: 'post'
    });
// 小组初始化账套
export const initialization = (params, opts) =>
    request('/api-course/team/init/accountset', params, {
        ...opts,
        method: 'post'
    });
// 创建小组
export const createGroup = (params, opts) =>
    request('/api-course/team/saveTeam', params, {
        ...opts,
        method: 'post'
    });
// 编辑小组
export const editorGroup = (params, opts) =>
    request('/api-course/team/updateTeam', params, {
        ...opts,
        method: 'post'
    });
// 获取岗位信息
export const getPostList = (id, params, opts) =>
    request('/api-resource/station/'+id, params, {
        ...opts
    });
// 获取小组学生
export const getTeamPage = (params, opts) =>
    request('/api-course/class/team/getTeamPage', params, {
        ...opts,
        method: 'post'
    });
// 查询小组学生
export const getTeamUser = (params, opts) =>
    request('/api-course/class/team/getTeamUser', params, {
        ...opts,
        method: 'post'
    });
// 编辑回显已选择的学生
export const getAddTeamStudent = (id, params, opts) =>
    request('/api-course/team/member/'+id, params, {
        ...opts
    });
// 获取科目id
export const getSubjectId = (id, params, opts) =>
    request('/api-course/class/query/'+id, params, {
        ...opts
    });
// 添加考试保存
export const addExam = (params, opts) =>
    request('/api-course/addCourseExam', params, {
        ...opts,
        method: 'post'
    });
// 编辑考试回显
export const examEcho = (courseId, paperId, params, opts) =>
    request('/api-course/get/exam/paper/info/'+courseId+'/'+paperId, params, {
        ...opts
    });
// 编辑考试保存
export const editorExam = (params, opts) =>
    request('/api-course/update/course/exam', params, {
        ...opts,
        method: 'post'
    });
// 删除考试
export const delExam = (courseId, paperId, examId, params, opts) =>
    request('/api-course/courseExam/'+courseId+'/'+paperId+'/'+examId, params, {
        ...opts,
        method: 'delete'
    });
// 回显试卷
export const getTestMsg = (paperId, params, opts) =>
    request('/api-course/get/course/exam/paper/'+paperId, params, {
        ...opts
    });
// 自动分组待分组人数
export const getGroupPeopleNum = (courseId, classId, params, opts) =>
    request('/api-course/team/find/autoGroups/notGroupPeopleNum/'+courseId+'/'+classId, params, {
        ...opts
    });
// 小组-我的岗位列表
export const getMyStation = (subjectId, params, opts) =>
    request('/api-course/team/find/autoGroups/getStationNameByCourseId/'+subjectId, params, {
        ...opts
    });
// 自动分组保存
export const saveAutoGroup = (courseId, classId, subjectId, peopleNum, params, opts) =>
    request('/api-course/team/save/autoGroups/autoGroupsByNum/'+courseId+'/'+classId+'/'+subjectId+'/'+peopleNum, params, {
        ...opts,
        method: 'post'
    });
// 自动换岗
export const automaticShift = (params, opts) =>
    request('/api-course/team/update/autoChangeStation', params, {
        ...opts,
        method: 'post'
    });
// 学生端阅读通知
export const studentNoticeRead = (messageid, params, opts) =>
    request('/api-cms/msg/read/'+messageid, params, {
        ...opts
    });

// 查询课程下的岗位
export const courseStation = (courseId, params, opts) =>
    request('/api-course/course/find/station/'+courseId, params, {
      ...opts
  });
// 课程授权判断
export const courseAuth = (id, params, opts) =>
    request('/api-course/course/find/auth/'+id, params, {
        ...opts
    });
// 检验试卷是否加密
export const checkPaperDecryption = (code, params, opts) =>
    request('/api-resource/testPaper/checkPaperDecryption?paperCode='+code, params, {
        ...opts
    });
// 试卷解密
export const usePaperDecryption = (params, opts) =>
     request('/api-resource/testPaper/usePaperDecryption', params, {
         ...opts,
		method: 'post'
     });
// 试卷使用记录
export const addPaperOperationRecord = (params, opts) =>
     request('/api-resource/testPaper/addPaperOperationRecord', params, {
         ...opts,
		method: 'post'
     });
// 教学空间测评
export const queryExam = (zid, sid, params, opts) =>
     request('/api-study/course/exam/userList/'+zid+'/'+sid, params, {
         ...opts
     });

// 回显试卷
export const getInitializationProgress = (courseId, classId, platform, params, opts) =>
    request(`/api-course/team/getInitCourseClassTeam/${courseId}/${classId}/${platform}`, params, {
        ...opts
    });

// 回显测评考试信息
export const getExamInfoByExamId = (examId, params, opts) =>
    request(`/api-course/getExamInfoByExamId/${examId}`, params, {
        ...opts
    });


// 学习中心 - 模拟考试  接口
// 学习中心 - 模拟考试
export const pageListForStudent = (params, opts) =>
  request('/api-teachingaffair/globalExam/pageListForStudent', params, {
      ...opts,
      method: 'post'
  });
// 跳转考试前的判断
export const ifIntoExamNew = (examId, params, opts) =>
    request('/api-teachingaffair/globalExam/getBeforeVerifyPractisePaper/'+examId, params, {
        ...opts
    });
    
// 获取是否展示惦尚直播推送按钮
export const getDSBtn = (params, opts) =>
    request(`/api-course/dianShang/isLiveClasses/${params.courseId}/${params.classId}`, {
        ...opts
    });
    
// 获取是否展示惦尚直播推送按钮
export const pushDsData = (params, opts) =>
    request(`/api-course/dianShang/dsTeam/${params.courseId}/${params.classId}/${params.examId}/${params.examType}`, {
        ...opts
    });


// WEBPACK FOOTER //
// ./src/api/individualApi.js